import { render, staticRenderFns } from "./OntStatistics.vue?vue&type=template&id=6dc98d80&"
import script from "./OntStatistics.vue?vue&type=script&lang=js&"
export * from "./OntStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports